export default {
  title: 'STRONA, KTÓREJ SZUKASZ, GDZIEŚ TU MUSI BYĆ...',
  description: 'Czy szukasz jednej z poniższych stron?',
  not_found: 'Nie możemy znaleźć podanego adresu URL. Sprawdź, czy został wpisany poprawnie.',
  no_restaurants: {
    title: 'Ten sklep nie przyjmuje jeszcze zamówień online',
    description: 'Zajrzyj tu wkrótce.',
  },
  toasts: {
    failed_to_load_stores: 'Nie udało się wczytać restauracji, odśwież stronę',
  },
};
